// 注释部分代码实现监听页面变化重新计算
(function(doc, win) {
    var docEl = doc.documentElement,
        isPad = (navigator.userAgent.match(/iPad/i) != null)?true:false;
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        if(clientWidth <= 414){
            docEl.style.fontSize = 100 * (clientWidth / 375) + 'px';
            return;
        }
        if(clientWidth > 414){
            docEl.style.fontSize = "16px";
            return;
        }
})(document, window);


// WEBPACK FOOTER //
// ./src/assets/js/rem.js